import MessageApi from '../../api/rest/dropboxMessageApi';
import employeeApi from '../../api/rest/employeeApi';

export const updateMessageStatus = async (messageId, statusId) => {
  const data = {id: messageId, messageStatusId: statusId};
  try {
    const result = await MessageApi.updateMessage(data);
    if (result) {
      console.log(`Message ${messageId} updated successfully.`);
      return true;
    } else {
      console.error(`Failed to update message ${messageId}. No result returned.`);
      return false;
    }
  } catch (error) {
    console.error('Error updating message:', error.message);
    return false;
  }
};

export const updateMessageIsRead = async (messageId, isRead) => {
  const data = {id: messageId, isRead};
  try {
    const result = await MessageApi.updateMessage(data);
    if (result) {
      console.log(`Message ${messageId} marked as read.`);
      return true;
    } else {
      console.error(`Failed to mark message ${messageId} as read.`);
      return false;
    }
  } catch (error) {
    console.error('Error updating message:', error.message);
    return false;
  }
};

export const updateMessagePublish = async (message) => {
  const messageId = message?.id;
  const statusId = 2;
  if (messageId) {
    return await updateMessageStatus(messageId, statusId);
  } else {
    console.error('Message ID is undefined or null.');
    return false;
  }
};

export const updateMessageReject = async (message) => {
  const messageId = message?.id;
  const statusId = 1;
  if (messageId) {
    return await updateMessageStatus(messageId, statusId);
  } else {
    console.error('Message ID is undefined or null.');
    return false;
  }
};

export const fetchEmployeesByDepartmentId = async (userDeptId) => {
  try {
    const response = await employeeApi.getEmployeeByDepartementId(userDeptId);
    if (response?.data) {
      return response.data.map((item) => ({
        id: item.id,
        text: item.fullName,
        group: 'Receivers',
      }));
    }
    return [];
  } catch (error) {
    console.error('Error fetching employees:', error);
    throw error;
  }
};
